import React, {
	useEffect,
	useMemo,
	useState,
} from 'react';
import { ConfigProvider, Switch } from 'antd';
import type { SeaPassageSettings } from '@api/utils/sequelize/calculateVoyageItineraryDetails/helpers/itineraryConstants';
import { usePortRotationProvider } from '../context/PortRotationContext';
import { PartialPortRotationEntry } from '../context/hooks/usePortRotationHandlers';

const SeaPassageSwitch = ({
	portRotationEntry,
	field,
	disabled,
}: {
	portRotationEntry: PartialPortRotationEntry;
	field: keyof SeaPassageSettings;
	disabled?: boolean;
}) => {
	const [checked, setChecked] = useState(Boolean(portRotationEntry.routeOptions?.[field]));
	const value = useMemo(
		() => portRotationEntry.routeOptions?.[field],
		[field, portRotationEntry.routeOptions],
	);

	const {
		onConfigUpdate,
		loading,
	} = usePortRotationProvider();
	const { componentDisabled } = ConfigProvider.useConfig();

	useEffect(() => {
		setChecked(Boolean(value));
	}, [value]);

	if (value === undefined || typeof value !== 'boolean') {
		return (<></>);
	}

	return (
		<Switch
			disabled={disabled || componentDisabled}
			loading={loading}
			checked={checked}
			onChange={(newValue) => {
				setChecked(newValue);

				return (
					portRotationEntry?.id != null && onConfigUpdate(portRotationEntry.id, {
						...portRotationEntry.routeOptions,
						[field]: newValue,
					}), true);
			}}
		/>
	);
};

export default SeaPassageSwitch;
